import { createSvgIcon } from '@mui/material';
import React from 'react';

export const MoveBooking = createSvgIcon(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 21H4V10H20V21ZM20 8H4V5H20V8Z"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
        />
        <path
            d="M11.182 18.4245L13.614 15.9925H7V14.4925H13.614L11.182 12.0605L12.2426 10.9999L16.4853 15.2425L12.2426 19.4852L11.182 18.4245Z"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
        />
    </svg>,
    'MoveBooking'
);
